import { Container, Grid, Paper } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Colaborador } from "../../../Interface/IInvestigadorUnidad";

export interface PublicacionesOdsProps {
    colaboraciones: Colaborador[]; // Propiedad para recibir la lista de proyectos
}

export const Colaboraciones: React.FC<PublicacionesOdsProps> = ({ colaboraciones }) => {
    const navigate = useNavigate();

    const columns: GridColDef[] = [

        { field: "investigador", headerName: "Investigador", flex: 0.5, resizable: false, sortable: false },
        { field: "institucion", headerName: "Institución", flex: 0.5, resizable: false, sortable: false },

    ];

    const rows = colaboraciones.map((colaboracion, index) => ({
        id: index, // El campo `id` es obligatorio para DataGrid
        investigador: colaboracion.nombre,
        institucion: colaboracion.institucion,

    }));


    const handleRowClick = (params: any) => {
        const { id } = params.row;
        navigate(`/publicacion/${id}`);
    };




    return (
        <Container>
            
            <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={8} md={8}>
                    <Paper elevation={3} style={{ width: "100%", height: 400 }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 25,
                                    },
                                },
                            }}
                            disableRowSelectionOnClick
                            disableColumnMenu
                            pagination
                            sx={{
                                "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: "blue !important",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                },
                                "& .MuiDataGrid-cell": {
                                    backgroundColor: "white",
                                    color: "black",
                                },
                               
                                // Ocultar el texto y el selector de "Rows per page"
                                "& .MuiDataGrid-footerContainer .MuiTablePagination-selectLabel": {
                                    display: "none", // Oculta el texto "Rows per page"
                                },
                                "& .MuiDataGrid-footerContainer .MuiTablePagination-select": {
                                    display: "none", // Oculta el selector de cantidad de filas
                                },
                                "& .MuiDataGrid-footerContainer .MuiInputBase-root": {
                                    display: "none", // Oculta el ícono del selector
                                },
                            }}
                        />

                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
};
